<template>
  <div class="hetongqianshu" :class="{ PDF: step === 6 }">
    <qianshuHeader />
    <ElectronicDocumentsAdd v-show="step === 1" />
    <qiangzhi v-show="step === 2" />
    <fengxian v-show="step === 3" />
    <fuwu v-show="step === 4" />
    <jieguo v-show="step === 5" />
    <ElectronicDocumentsPDF v-show="step === 6" />
    <chenggong v-show="step === 7" />
    <!-- 屎一样的样式设计 -->
    <qiangzhijieguo />
    <fengxianjieguo />
    <messageDialog ref="messageDialogRef" @close="close" />
  </div>
</template>

<script>
import messageDialog from "@/components/messageDialog/messageDialog.vue";
import qianshuHeader from "./components/qianshuHeader.vue";
import ElectronicDocumentsAdd from "@/views/ElectronicDocuments/ElectronicDocumentsAdd.vue";
import ElectronicDocumentsPDF from "@/views/ElectronicDocuments/ElectronicDocumentsPDF.vue";
import fengxian from "./step/fengxian.vue";
import fuwu from "./step/fuwu.vue";
import qiangzhi from "./step/qiangzhi.vue";
import jieguo from "./step/jieguo.vue";
import chenggong from "./step/chenggong.vue";
import qiangzhijieguo from "./step/shit/qiangzhijieguo.vue";
import fengxianjieguo from "./step/shit/fengxianjieguo.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    qianshuHeader,
    ElectronicDocumentsAdd,
    fengxian,
    fuwu,
    qiangzhi,
    jieguo,
    ElectronicDocumentsPDF,
    chenggong,
    qiangzhijieguo,
    fengxianjieguo,
    messageDialog,
  },
  data() {
    return {};
  },
  mounted() {
    const { detectionId } = this.$route.query;
    if (detectionId) {
      this.setStep(3);
      this.getDetectionDetail(detectionId);
      return;
    }
    //  根据这个判断是不是从支付宝跳转回来的
    // const { detectionId } = this.$route.query;
    // if (detectionId) {
    //   this.setStep(4);
    //   return;
    // }
    if (this.subject) {
      this.$refs.messageDialogRef.onShow({
        title: "重要提示",
        content: "您有一个「发起签署」流程在进行中",
        confirmText: "继续编辑",
        cancelText: "重新发起",
      });
    }
  },
  created() {},
  computed: {
    subject() {
      return this.$store.state.ElectronicDocumentsAdd.subject;
    },

    ...mapState("hetongqianshu", ["step"]),
  },
  methods: {
    ...mapActions("hetongqianshu", ["setStep"]),
    ...mapActions("fengxian", ["setjieguo"]),
    close() {
      this.$store.dispatch("hetongqianshu/clearData", { type: "toStep1" });
    },
    async getDetectionDetail(detectionId) {
      const { data, status, info } = await this.$api.getDetectionDetail({ detectionId });
      if (status !== 200) {
        this.$message({
          type: "error",
          message: info,
        });
        return;
      }
      this.setjieguo(data);
    },
  },
};
</script>

<style scoped lang="scss">
.hetongqianshu {
  @include contentStyle4;
}
.PDF {
  padding-left: 0;
  padding-right: 0;
  @include contentStyle3;
  max-width: none;
  padding-left: 0;
  padding-right: 0;
}
</style>
